import { Row, Col, Card, Table, DatePicker, Tag } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function ExpiredSubscription({ data, loading }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const userTypeMapping = {
    admin: "Administrator",
    user: "Regular User",
    gamingHall: "Gaming Hall",
    vendor: "Vendor",
    designer: "Designer",
  };
  const columns = [
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
      render: (userType) => userTypeMapping[userType] || "Unknown",
    },
    
    {
      title: "title",
      dataIndex: "subscriptionId",
      key: "subscriptionId",
      render: (_, { subscriptionId }) => {
        return (
          <span className="">
            {subscriptionId?.title}
          </span>
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "userId",
      key: "userId",
      render: (_, { userId }) => {
        return (
          <span className="">
            {userId?.name}
          </span>
        );
      },
    },
    {
      title: "Admin Cut(AED)",
      render: (_, record) => {
        return (
          <div>
            <span className="">{((record?.subscriptionId?.price)*(record?.userId?.adminCommission)/100)}</span>
          </div>
        );
      },
    },
    {
      title: "Amount(AED)",
      dataIndex: "subscriptionId",
      key: "subscriptionId",
      render: (_, { subscriptionId }) => {
        return (
          <span className="">
            {subscriptionId?.price}
          </span>
        );
      },
    },
    {
      title: "Purchased At",
      dataIndex: "created_at",
      key: "created_at",
      render: (_, { created_at }) => {
        return (
          <span className="">
            {created_at ? moment(created_at).format("lll") : "NA"}
          </span>
        );
      },
    },
    {
      title: "Expired At",
      dataIndex: "subscriptionExpireDate",
      key: "subscriptionExpireDate",
      render: (_, { subscriptionExpireDate }) => {
        return (
          <span className="">
            {subscriptionExpireDate ? moment(subscriptionExpireDate).format("lll") : "NA"}
          </span>
        );
      },
    },
    {
      title: "Subscription Status",
      dataIndex: "subscriptionStatus",
      key: "subscriptionStatus",
      render: (subscriptionStatus) => {
        if (!subscriptionStatus) return "N/A"; // Handle cases where subscriptionId is missing
        return subscriptionStatus==="active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Past</Tag>
        );
      },
    },
  ];
  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default ExpiredSubscription;
